var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 162,
    viewBox: "0 0 161 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_141_11040)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_11040)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_141_11040)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_141_11040",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 29,
    width: 81,
    height: 81
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.209 29.209H120.526V109.526H40.209V29.209Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_141_11040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.9785 84.6269C81.9785 84.6269 80.6452 81.4142 80.377 81.146C113.31 65.3395 118.155 75.4595 118.833 79.6119C118.942 80.2834 118.841 80.9661 118.634 81.615C117.875 83.9848 116.896 86.2785 115.71 88.4661C113.301 90.8756 99.6467 91.0523 99.6467 91.0523L81.9785 84.6269Z",
    fill: "#144496"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9437 51.6974L80.3755 57.5879C47.4422 73.3943 42.5974 63.2743 41.9196 59.1219C41.8103 58.4505 41.9115 57.7678 42.1187 57.1188C42.7384 55.1815 43.5052 53.2944 44.4126 51.4741C50.9938 38.2747 63.5041 46.8783 63.5041 46.8783L73.9437 51.6974Z",
    fill: "#1A6F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1168 81.6162C41.9096 80.9672 41.8084 80.2845 41.9176 79.6131C42.5955 75.4591 47.4402 65.3391 80.3736 81.1471C103.179 92.0944 112.517 90.6085 116.327 87.2802C109.742 100.467 96.1158 109.527 80.3736 109.527C62.466 109.527 47.2957 97.805 42.1168 81.6162Z",
    fill: "#2EBCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.63 57.1193C118.837 57.7683 118.938 58.451 118.829 59.1224C118.151 63.2764 113.307 73.3964 80.3732 57.5884C57.5679 46.6411 48.2302 48.127 44.4199 51.4553C51.0043 38.2688 64.631 29.209 80.3732 29.209C98.2792 29.209 113.45 40.9305 118.63 57.1193Z",
    fill: "#1AD3BB"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_141_11040",
    x: 0.0521603,
    y: 0.52608,
    width: 160.635,
    height: 160.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.4739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_11040"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_11040",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_11040"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_141_11040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.3174,
    height: 80.3174,
    fill: "white",
    transform: "translate(40.2109 29.2109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.4faeb1b0896a83ef05a5760b59acc609.svg";
export { ForwardRef as ReactComponent };